import { getAngularJsService, goto } from '../../Js/React/Services/legacy';
import BizCarousel from '../../Js/React/UI/BizCarousel/BizCarousel';
import useWindowSize from '../../FrontEndReact/src/Core/Hooks/useWindowSize';
import BizPhrase from './Phrase';

//todo translation, add i18n in react?

export interface ListObject {
	Id: number;
	Name: string;
	Description: string;
	ImageUrl: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	EngageObjects: any[];
	Url?: { state: string; params?: Record<string, string | number> };
	OverrideTypeLabel?: string;
	OverrideTypeLabels?: ObjectTypeLabelProps[];
	BannerTitle?: string;
	BannerText?: string;
	BannerClass?: string;
}

const LAYOUTS = ['hero', 'row', 'carousel']; //todo: row implementation
const DEFAULT_LAYOUT = 'hero';
const DEFAULT_LIMIT = 3;

export type ObjectType = 'JOURNEY' | 'EVENT' | 'BLOG' | 'MEDIA' | 'EDUCATION';
const DEFAULT_OBJECT_TYPE: ObjectType = 'JOURNEY';

interface ObjectMiniListProps {
	objects: ListObject[];
	layout?: string;
	layoutMobile?: string;
	limit?: number;
	itemsPerRow?: number;
	type?: ObjectType;
	labelStyle?: string;
}

interface OneListObjectProps {
	obj: ListObject;
	type: ObjectType;
	labelStyle?: string;
}

type ObjectTypeLabelProps = {
	type: ObjectType;
	overrideLabels?: string[];
	overrideIcon?: string;
	index?: number;
	labelStyle?: string;
};

const ObjectTypeLabel = ({ type, overrideLabels, overrideIcon, index, labelStyle }: ObjectTypeLabelProps) => {
	//todo translations and more item type support

	const labelclasses = `label-index-${index ?? 0} label-style-${labelStyle ?? 'default'}`;
	let iconClass = 'fa-light fa-map-location-dot';
	/*let typeName = 'Resa';*/

	if (type === 'EVENT') {
		iconClass = 'fas fa-calendar-alt';
		/*typeName = 'Event';*/
	} else if (type === 'BLOG') {
		iconClass = 'fas fa-newspaper';
		/*typeName = 'Artikel';*/
	} else if (type === 'MEDIA') {
		iconClass = 'fa-regular fa-circle-play';
		/*typeName = 'Video';*/
	} else if (type === 'EDUCATION') {
		iconClass = 'fa-solid fa-graduation-cap';
		/*typeName = 'Utbildning';*/
	}

	iconClass = overrideIcon !== undefined && overrideIcon.length >= 0 ? overrideIcon : iconClass;

	return (
		<div className={`one-item-type-name ${labelclasses}`}>
			{!overrideLabels && (
				<span>
					<BizPhrase phraseKey={`ONE_ITEM_${type}`}></BizPhrase>
				</span>
			)}
			{overrideLabels &&
				overrideLabels.length > 0 &&
				[...overrideLabels].reverse().map((label, spanIndex) => (
					<span key={spanIndex} className={`label-${spanIndex}`}>
						{label}
					</span>
				))}
			{iconClass && <i className={iconClass}></i>}
		</div>
	);
};

const OneListObject = ({ obj, type, labelStyle }: OneListObjectProps) => {
	const { isMobile } = useWindowSize();

	const bizJourneyService = getAngularJsService('bizJourneyService');
	const baseService = getAngularJsService('base.service');

	const getSiteRootPath = (url: string) => {
		return baseService.GetSiteRootPath(url);
	};

	//cannot get uirouter working with a link here, so we have to do it this way for now
	const objectClickHandler = () => {
		//todo: set state/params on each object so it works on other types than journeys
		if (obj.Url) {
			//console.log('go to', obj.Url.state, obj.Url.params);
			goto(obj.Url.state, obj.Url.params);
		} else if (obj.EngageObjects.length > 0) {
			bizJourneyService.GoToEngageItem(obj.EngageObjects[0]);
		} else {
			console.log('cannot go to first item in journey, as there isnt any items journey');
		}
	};

	//console.log('one object', obj);

	return (
		<div className={`mini-list-object${obj.BannerText ? ' has-banner' : ''}`} onClick={objectClickHandler}>
			{!!obj.BannerText && (
				<div className={`banner ${obj.BannerClass ?? ''}`}>
					<div className='banner-content'>
						{obj.BannerTitle && <span className='banner-title'>{obj.BannerTitle}</span>}
						<span className='banner-text'>{obj.BannerText}</span>
					</div>
				</div>
			)}
			<div
				className='image'
				style={{
					backgroundImage: `url(${getSiteRootPath(obj.ImageUrl)})`,
				}}
			></div>
			{!obj.OverrideTypeLabels && <ObjectTypeLabel type={type} labelStyle={labelStyle}></ObjectTypeLabel>}
			{obj.OverrideTypeLabels?.map((l, index) => (
				<ObjectTypeLabel
					key={index}
					type={l.type}
					overrideLabels={l.overrideLabels}
					overrideIcon={l.overrideIcon}
					index={index}
					labelStyle={labelStyle}
				></ObjectTypeLabel>
			))}
			<div className='information'>
				<h3 className='line-limit lines-2'>{obj.Name}</h3>
				<p className='line-limit lines-2'>{obj.Description}</p>
				<span onClick={objectClickHandler} className={`read-more ${isMobile ? 'biz-btn biz-primary' : ''}`}>
					<BizPhrase phraseKey={`GLOBAL.READ_MORE`}></BizPhrase>
				</span>
				<div></div>
			</div>
		</div>
	);
};

const ObjectCarousel = ({ objects, type, labelStyle }: ObjectMiniListProps) => {
	console.log('carusel', objects);
	return (
		<BizCarousel
			settings={{
				arrows: false,
				autoplay: false,
				dots: false,
				infinite: false,
				slidesToScroll: 1,
				slidesToShow: objects.length > 1 ? 1.05 : 1,
				centerMode: objects.length > 1 ? true : false,
				centerPadding: objects.length > 1 ? '1%' : undefined,
			}}
		>
			{objects.map((obj) => (
				<OneListObject obj={obj} key={obj.Id} type={type || DEFAULT_OBJECT_TYPE} labelStyle={labelStyle}></OneListObject>
			))}
		</BizCarousel>
	);
};

const ObjectMiniList = ({ objects, layout, layoutMobile, limit, itemsPerRow, type, labelStyle }: ObjectMiniListProps) => {
	const { isMobile } = useWindowSize();

	const getRowLimit = (listLayout, listLimit) => {
		if (listLayout === 'row') {
			const configuredItemsPerRow = itemsPerRow ?? listLimit;
			return configuredItemsPerRow === 4 ? 4 : DEFAULT_LIMIT;
		}
		if (listLayout === 'hero' && listLimit > 4) {
			return DEFAULT_LIMIT;
		}

		return DEFAULT_LIMIT;
	};

	const listLayout = LAYOUTS.find((l) => l.toLowerCase() === layout?.toLowerCase()) ?? DEFAULT_LAYOUT;
	const listLimit = limit ?? (itemsPerRow === undefined ? DEFAULT_LIMIT : objects.length);
	const rowLimit = getRowLimit(listLayout, listLimit);

	const containerClass = 'object-mini-list ' + listLayout + '-' + rowLimit;
	const totalAvailable = Math.min(objects.length, listLimit);

	const firstCount = isMobile ? totalAvailable : Math.min(rowLimit, totalAvailable);
	const secondStart = firstCount;
	const secondEnd = totalAvailable;
	const hasSecondBlock = !isMobile && secondEnd > secondStart;

	if (listLayout === 'carousel' || (isMobile && layoutMobile === 'carousel')) {
		return (
			<div className={containerClass}>
				<ObjectCarousel objects={objects} limit={listLimit} type={type || DEFAULT_OBJECT_TYPE} labelStyle={labelStyle} />
			</div>
		);
	}

	if (listLayout === 'row') {
		return (
			<div className={containerClass}>
				{objects.slice(0, totalAvailable).map((obj) => (
					<OneListObject
						obj={obj}
						key={obj.Id}
						type={type || DEFAULT_OBJECT_TYPE}
						labelStyle={labelStyle}
					></OneListObject>
				))}
			</div>
		);
	}

	return (
		<>
			<div className={containerClass}>
				{objects.slice(0, firstCount).map((obj) => (
					<OneListObject
						obj={obj}
						key={obj.Id}
						type={type || DEFAULT_OBJECT_TYPE}
						labelStyle={labelStyle}
					></OneListObject>
				))}
			</div>
			{hasSecondBlock && (
				<div className='object-mini-list row-4'>
					{objects.slice(secondStart, secondEnd).map((obj) => (
						<OneListObject
							obj={obj}
							key={obj.Id}
							type={type || DEFAULT_OBJECT_TYPE}
							labelStyle={labelStyle}
						></OneListObject>
					))}
				</div>
			)}
		</>
	);
};

export default ObjectMiniList;
